export default __webpack_public_path__ + "static/media/placeholder.9846c6b8.svg";